import React from "react";
import { SCENARIO } from "../scenario/torbridge.js";

export function DisclosureBanner() {
  return (
    <div className="disclosure-banner" role="note">
      <span className="disclosure-dot" aria-hidden="true" />
      <span>{SCENARIO.disclosure}</span>
    </div>
  );
}
